import { useEffect, useState } from 'react';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { BasicPage } from '../../../theme/Component/BasicPage';
import { BasicTable, MASK_DECIMAL, MASK_MONEY } from '../../../theme/Component/BasicTable';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { Modal } from '../../../theme/Component/Modal';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import { AccountantBookEditor } from '../AccountantBook/AccountantBookEditor';
import './Company-css.css';
import { CompanyService } from './Company-service';
import { Singleton } from '../../../../core/services/Singleton';
import { useDashboardStore } from '../../../pages/hooks/useDashboardStore';
import { AccountEditor } from '../../../editor/AccountEditor';
import { FileInput } from '../../../theme/Component/FileInput';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Company, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select/dist/declarations/src/Select';
import { SelectAccountantIDType } from '../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/SelectAccountantIDType';
import { SelectBudgetIDType } from '../../../admin/configuracion/select/SelectBudgetIDType';
import { SelectAccountantIDLevelConstants } from './Components/SelectAccountantIDLevelConstants';
import { SelectAccountantReportTypeConstants } from './Components/SelectAccountantReportTypeConstants';
import { CurrencyEditor } from '../Currency/CurrencyEditor';
import { CountriesEditor } from '../../../Inventories-Warehouses/Product/Countries/CountriesEditor';
import { InputMoney } from '../../../theme/Input/InputMoney';
import { TaxHoldeditor } from '../../../Talentohumano/ParametrosTalentoHumano/EmployeePayments/EmployeePayments.editor';

export const Company = () => {
    const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState([]);
    const [modalcaracttramites, setModalcaracttramites] = useState<any>({ name: "Caracterizaciones Para Prueba", tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: "modal-md", });
    const [modala, setModala] = useState<any>({ name: "Agregar Item", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg" });
    const [meliminar, setMeliminar] = useState<any>({ name: "Confirmar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm" });
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new CompanyService();
    const modalProps = useModal(`Propiedades de la compañia ${bean.Name}`, MODAL_LG)

    const idBean = "IDCompany";

    const setRowBean = (bean: any) => {
        setBean(bean);
        //console.log(bean)
    };

    useEffect(() => {
        getCompanyCatalog();
    }, [])

    useEffect(() => {
        if (bean.IDCompany) {
            bean.DocTemplateJsonProperties ? setBean({ ...bean, "DocTemplateJsonProperties": JSON.stringify(bean.DocTemplateJsonProperties) }) : setBean({ ...bean, "HeaderImageJsonProperties": "" });
            bean.FooterImageJsonProperties ? setBean({ ...bean, "FooterImageJsonProperties": JSON.stringify(bean.FooterImageJsonProperties) }) : setBean({ ...bean, "HeaderImageJsonProperties": "" });
            bean.HeaderImageJsonProperties ? setBean({ ...bean, "HeaderImageJsonProperties": JSON.stringify(bean.HeaderImageJsonProperties) }) : setBean({ ...bean, "HeaderImageJsonProperties": "" });
        }
    }, [bean.IDCompany])

    const agregarItem = () => {
        let b = {
            Name: "",
            Description: "",
            // IDBusinessClass: idModule,
            Code: 0,
            IDCompany: "",
            CountryCode: 0,
            IDAccount: _single.getAccountID(),
            IDAccountRepresentative: 6139,
            IDAccountantBook: 1,
            HeaderReportName: "",
            DocTemplateMedia: null,
            DocTemplateMediaContext: null,
            HeaderImageMedia: null,
            HeaderImageMediaContext: null,
            FooterImageMedia: null,
            FooterImageMediaContext: null,
            FontMediaContext: null,
            FontMedia: "",
            HeaderImageJsonProperties: "",
            FooterImageJsonProperties: "",
            DocTemplateJsonProperties: "",
        };
        setBean(b);
        setModala({ ...modala, "view": true });
    };

    const getCompanyCatalog = () => {
        setLoading(true);
        service
            .getCompanyCatalog(null)
            .subscribe((resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            });
    };

    const caracterizaciontramites = () => {
        setModalcaracttramites({ ...modalcaracttramites, 'view': true });
    }

    const eliminarItem = () => {
        setLoading(true);
        service.deleteCompany(bean[idBean]).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getCompanyCatalog();
                }
                single.delete(bean[idBean], bean);
            }
        );
        setMeliminar({ ...meliminar, 'view': false });
    }

    const updateItem = () => {
        setModala({ ...modala, 'view': false });
        setLoading(true);
        service.updateCompany(bean).subscribe((resp: any) => {
            setLoading(false);
            if (resp.DataBeanProperties.ObjectValue) {
                getCompanyCatalog();
            }
            single.update(bean)
            modalProps.close();
        });
    };


    const head = [
        { title: "ID ", property: idBean },
        // { title: "ID compañia", property: "IDCompany" },
        { title: "Código País", property: "CountryCode" },
        { title: "País", property: "CountryName" },
        { title: "Nombre de la Compañía", property: "Name" },
        { title: 'Tipo Moneda', property: 'CurrencyName', visible: true },
        { title: "Descripción", property: "Description" },
        { title: "Tercero de la Empresa", property: "IDAccount" },
        { title: "Código de la Compañía", property: "Code" },
        { title: "Tercero Representante Legal", property: "IDAccountRepresentative" },
        { title: "Salario Mínimo", property: "MinSalaryValue",mask:MASK_MONEY },
        { title: "Valor UVT", property: "UVTValue",mask:MASK_DECIMAL },    
        { title: 'Archivo de Logo', property: 'LogoImageMedia', visible: true },
        { title: "Cargar archivo Plantilla", property: "DocTemplateMedia" ,visible:false },
        { title: "Imágen Header Reportes", property: "HeaderImageMedia" ,visible:false},
        { title: "Imágen Footer Reportes", property: "FooterImageMedia" ,visible:false},
        { title: "Título Reportes", property: "HeaderReportName" },
        { title: "Fuente de Reportes", property: "FontMedia" },
        { title: "Json Header", property: "HeaderImageJsonProperties" ,visible:false},
        { title: "Json Footer", property: "FooterImageJsonProperties",visible:false},
        { title: "Json Configurar Reportes", property: "DocTemplateJsonProperties" ,visible:false},
        { title: "Fecha de Creación", property: "Since" },

    ];

    const listaBotones = () => {
        const botones = [
            { titulo: "Editar", icono: "ri-file-list-line", visible: true, evento: () => { setModala({ ...modala, view: true, name: 'Editar' }); }, },
            { titulo: "Eliminar", icono: "ri-file-user-line", visible: true, evento: () => { setMeliminar({ ...meliminar, view: true }); }, },
            { titulo: "Consultar/Editar Propiedades Contables/Presupuestales", icono: "ri-settings-5-line", visible: true, evento: () => { modalProps.open() }, },

        ];
        return <ListMenu listaBotones={botones} />;
    };

    const iconButtonsItem = [
        {
            nombre: "Agregar",
            visible: single.canCreate(),
            icono: "ri-file-add-line",
            evento: agregarItem,
        },
    ];

    const props = useDataBean(_Company);

    const getCompanyNew = () => {
        props.instance.getAccountingCompanyProperties(bean.IDCompany).then(
            (resp) => {
                setBean(resp);
            }
        ).catch(err => { toast.error(err) })
    }

    useEffect(() => {
        if (modalProps.modal?.view) {
            getCompanyNew()
        }
    }, [modalProps.modal?.view])

    return (
        <BasicPage titulo="Compañias">
            <div className="row">
                <div className="col-md-12 p-2">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                </div>
            </div>
            <ModalConfirm modal={meliminar} updateModal={setMeliminar} eventModal={eliminarItem}>
                {bean.name}
            </ModalConfirm>

            <Modal modal={modala} updateModal={setModala} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Código de la Compañía</label>
                        <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, 'Code': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Código País</label>
                        <input type="text" className="form-control" value={bean.CountryCode} onChange={(e) => { setBean({ ...bean, 'CountryCode': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Nombre de la Compañía</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, 'Name': e.target.value }) }} />
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Título Reportes</label>
                        <textarea className="form-control" value={bean.HeaderReportName} onChange={(e) => { setBean({ ...bean, 'HeaderReportName': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Tercero de la Empresa</label>
                        <AccountEditor idAccount={bean.IDAccount} label="Funcionario" onChange={({ IDAccount }: any) => { setBean({ ...bean, "IDAccount": IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Tercero Representante Legal</label>
                        <AccountEditor idAccount={bean.IDAccountRepresentative} label="Funcionario" onChange={({ IDAccount }: any) => { setBean({ ...bean, "IDAccountRepresentative": IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Libro Contable</label>
                        <AccountantBookEditor id={bean.IDAccountantBook} onchange={(e: any) => { setBean({ ...bean, 'IDAccountantBook': e }) }}></AccountantBookEditor>
                    </div>
                    <div className="col-md-12">
                        <CountriesEditor render={bean.CountryName} idSelector={bean.IDCountries} onChange={(e) => { setBean({ ...bean, "IDCountries": e.IDCountries, "CountryName": e.Name }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={bean.IDCurrency} onchange={(e) => { setBean({ ...bean, IDCurrency: e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label"></label>
                        <FileInput
                            Media={bean.DocTemplateMedia}
                            MediaContext={bean.DocTemplateMediaContext}
                            directory='Template'
                            label='Cargar archivo Plantilla'

                            onCreate={(Filemap: any) => { setBean({ ...bean, "DocTemplateMedia": Filemap.Media, "DocTemplateMediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label"></label>
                        <FileInput
                            Media={bean.HeaderImageMedia}
                            MediaContext={bean.HeaderImageMediaContext}
                            directory='Template'
                            label='Imágen de Header para Reporte'

                            onCreate={(Filemap: any) => { setBean({ ...bean, "HeaderImageMedia": Filemap.Media, "HeaderImageMediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label"></label>
                        <FileInput
                            Media={bean.FooterImageMedia}
                            MediaContext={bean.FooterImageMediaContext}
                            directory='Template'
                            label='Imágen de Footer para Reportes'

                            onCreate={(Filemap: any) => { setBean({ ...bean, "FooterImageMedia": Filemap.Media, "FooterImageMediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label"></label>
                        <FileInput
                            Media={bean.FontMedia}
                            MediaContext={bean.FontMediaContext}
                            directory='Template'
                            label='Fuente de Reportes'

                            onCreate={(Filemap: any) => { setBean({ ...bean, "FontMedia": Filemap.Media, "FontMediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label"></label>
                        <FileInput
                            Media={bean.LogoImageMedia}
                            MediaContext={bean.LogoImageMediaContext}
                            directory='Template'
                            label='Archivo de Logo'

                            onCreate={(Filemap: any) => { setBean({ ...bean, "LogoImageMedia": Filemap.Media, "LogoImageMediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Json para Configurar imágen de Header</label>
                        <textarea className="form-control" value={bean.HeaderImageJsonProperties} onChange={(e) => { setBean({ ...bean, 'HeaderImageJsonProperties': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label"> Json para Configurar imágen de Footer</label>
                        <textarea className="form-control" value={bean.FooterImageJsonProperties} onChange={(e) => { setBean({ ...bean, 'FooterImageJsonProperties': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label"> Json para Configurar Reportes</label>
                        <textarea className="form-control" value={bean.DocTemplateJsonProperties} onChange={(e) => { setBean({ ...bean, 'DocTemplateJsonProperties': e.target.value }) }}></textarea>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalProps.modal} updateModal={modalProps.setModal} eventModal={() => { updateItem() }}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectAccountantIDType idSelector={bean.IDAccountantIDType} onChange={(e) => { setBean({ ...bean, IDAccountantIDType: e }) }} label='Tipo de Plan de Cuentas' />
                    </div>
                    <div className="col-md-6">
                        <SelectBudgetIDType idSelector={bean.IDBudgetIDType} onChange={(e) => { setBean({ ...bean, IDBudgetIDType: e }) }} label='Tipo de Presupuesto' />
                    </div>
                    <div className="col-md-6">
                        <SelectAccountantIDLevelConstants idSelector={bean.MinAccountantIDLevel} onChange={(e) => { setBean({ ...bean, MinAccountantIDLevel: e }) }} label='Mínimo nivel de registro contable' />
                    </div>
                    <div className="col-md-6">
                        <SelectAccountantReportTypeConstants idSelector={bean.AccountantReportType} onChange={(e) => { setBean({ ...bean, AccountantReportType: e }) }} label='Tipo de Presentación de Saldos Contables' />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _value={bean.MinSalaryValue} _label='Salario Mínimo' onChange={(e)=>{setBean({...bean,"MinSalaryValue":e})}}/>
                    </div>
                    <div className="col-md-6">
                        <InputMoney _style='decimal' _value={bean.UVTValue} _label='Valor UVT' onChange={(e)=>{setBean({...bean,"UVTValue":e})}}/>
                    </div>
                    <div className="col-md-6">
                        <TaxHoldeditor renderType='Table' idSelector={bean.IDTaxHoldSalary} label='Factor de Retención Salarios/Ingresos' 
                        onChange={(e)=>{setBean({...bean,"IDTaxHoldSalary":e})}}
                        />
                    </div>
                    <div className="col-md-6">
                        <TaxHoldeditor renderType='Table' idSelector={bean.IDTaxHoldRetention} label='Factor de Retención Practicada/Calculada' 
                        onChange={(e)=>{setBean({...bean,"IDTaxHoldRetention":e})}}
                        />
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}


